export const EChargeMethodType = {
  Pix: 0,

  CheckoutRedirect: 1,
}

export type EChargeMethodType = (typeof EChargeMethodType)[keyof typeof EChargeMethodType]
